import store, {toast} from '@/store'

import {apiAxios} from '@/router/auth'

export default {
  state: {
    user_tickets: []
  },
  getters: {},
  actions: {
    fetchUserTickets ({commit}) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/users/${store.getters.getUser.id}/tickets`).then(response => {
          commit('setUserTickets', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    userTransitionTicket (context, data) {
      return new Promise((resolve, reject) => {
        apiAxios.put(`/tickets/user/${data.ticket_id}`, data).then(response => {
          if (response.data.files) {
            context.dispatch('fetchTicketFiles', { ticketId: response.data.id, files: response.data.files })
          }
          context.commit('setTicket', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject()
        })
      })
    },
  },
  getters: {
    userTickets: state => {
      return state.user_tickets
    },
  },
  mutations: {
    setUserTickets (state, tickets) {
      state.user_tickets = tickets
    },
    addTicket (state,  ticket) {
      state.user_tickets.push(ticket)
    },
    updateUserTickets (state, ticket) {
      var elementPos = state.user_tickets.map(function(x) {return x.id; }).indexOf(ticket.id);
      state.user_tickets.splice(elementPos, 1, ticket)
    }
  }
}
